<div class="main-wrapper">
  <div class="container">

    <div class="painel-esquerdo">
      <img src="ExbeBranco.png" alt="Logo" class="logo" /> </div>

    <div class="right-panel">
      <h1>Fazer login na conta</h1>
      <p>Preencha seus dados</p>

      <form class="form" [formGroup]="loginUsuario" (ngSubmit)="enviarFormulario()">
        
        <div class="form-group">
          <label for="email">Email</label>
          <input type="email" class="form-control" id="email" formControlName="email" placeholder="Digite seu email">
          
          <div *ngIf="loginUsuario.get('email')?.invalid && loginUsuario.get('email')?.touched">
            <div *ngIf="loginUsuario.get('email')?.hasError('required')" class="formatacaoRequireds">
              *Email é obrigatório
            </div>
            <div *ngIf="loginUsuario.get('email')?.hasError('email')" class="formatacaoRequireds">
              *Email inválido
            </div>
          </div>
        </div>

        <div class="form-group position-relative">
          <label for="senha">Senha</label>

          <input
            [type]="mostrarSenha ? 'text' : 'password'"
            class="form-control"
            id="senha"
            formControlName="senha"
            placeholder="Digite sua senha"
          />

          <i
            class="bi"
            [ngClass]="mostrarSenha ? 'bi-eye-slash' : 'bi-eye'"
            (click)="toggleSenha()"
            style="position: absolute; right: 15px; top: 38px; cursor: pointer;"
          ></i>

          <div *ngIf="loginUsuario.get('senha')?.invalid && loginUsuario.get('senha')?.touched">
            <div *ngIf="loginUsuario.get('senha')?.hasError('required')" class="formatacaoRequireds">
              *Senha é obrigatória
            </div>
          </div>
        </div>
        
        <button class="btn-entrar w-100" type="submit">
          Entrar
        </button>
        
        <div class="linksEsqueciSenha">
          <a href="#" (click)="abrirModalEsqueciSenha(); $event.preventDefault()">Esqueci minha senha.</a>
        </div>

        <div class="links">
          Ainda não tem conta? Contate o administrador.
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Modal Esqueci Minha Senha -->
<app-redefinicao-senha *ngIf="showForgotPasswordModal" (fecharModal)="fecharModalEsqueciSenha()"></app-redefinicao-senha>